<template>
  <div>
    <multiselect
      v-model="selected"
      :options="options"
      placeholder="Type to search"
      track-by="id"
      label="name"
      :max-height="125"
      :allow-empty="allowEmpty"
      :multiple="isMultiple"
      :disabled="isDisabled"
    >
      <span slot="noResult">Oops! No data found</span>
      <template slot="singleLabel" slot-scope="props">
        <span class="option__desc">
          <span class="option__title"
            >{{ props.option.code_external }} {{ props.option.name }}</span
          >
        </span>
      </template>

      <template slot="option" slot-scope="props">
        <div class="option__desc">
          <span class="option__title"
            >{{ props.option.code_external }} {{ props.option.name }}</span
          >
        </div>
      </template>
    </multiselect>
  </div>
</template>
<script>
import { RepositoryFactory } from "@/repositories/repositoryFactory";

const MasterRepository = RepositoryFactory.get("master");

export default {
  props: {
    isMultiple: {
      type: Boolean,
      default: false,
    },
    allowEmpty: {
      type: Boolean,
      default: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isGetData: {
      type: Boolean,
      default: false,
    },
    territoryID: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      options: [],
      selected: null,
    };
  },
  methods: {
    async setSelectedData(data) {
      this.selected = data;
    },
    async getData(params) {
      try {
        const newParams = {
          ...params,
          territory_id: this.territoryID,
        };
        const resp = await MasterRepository.getSales(newParams);
        if (resp.code == 200) {
          this.options = [];
          var options = [];
          resp.data.forEach(function (item) {
            options.push(item);
          }, options);
          this.options = options;
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: error.message,
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        console.log(error);
      }
    },
  },
  watch: {
    selected(v) {
      if (v) {
        this.$emit("data", v);
      }
    },
    territoryID: {
      handler: function (val) {
        console.log("territoryID", val);
        this.territoryID = val;
        this.getData();
      },
      deep: true,
    },
  },
  mounted() {
    if (this.isGetData) {
      this.getData();
    }
  },
};
</script>
